import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum CompanyMasterServicesStatusIds {
  NO_SERVICES = 1,
  SOME_IN_REVIEW = 2,
  IN_REVIEW = 3,
  SOME_READY_FOR_CONTRACTS = 4,
  READY_FOR_CONTRACTS = 5,
  SOME_ASSIGNED = 6,
  ASSIGNED = 7,
  SOME_ACTIVE = 8,
  ACTIVE = 9,
  SOME_SUSPENDED = 10,
  SUSPENDED = 11,
  SOME_DISCONNECTED = 12,
  DISCONNECTED = 13,
  SOME_REACTIVATED = 14,
  REACTIVATED = 15,
}

export function getCompanyMasterServicesStatii(): ISelectItem[] {
  return [
    {
      id: CompanyMasterServicesStatusIds.NO_SERVICES,
      label: 'No Services',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.SOME_IN_REVIEW,
      label: 'Some In Review',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.IN_REVIEW,
      label: 'In Review',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.SOME_READY_FOR_CONTRACTS,
      label: 'Some Ready for Contracts',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.READY_FOR_CONTRACTS,
      label: 'Ready for Contracts',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.SOME_ASSIGNED,
      label: 'Some Assigned',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.ASSIGNED,
      label: 'Assigned',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.SOME_ACTIVE,
      label: 'Some Active',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.ACTIVE,
      label: 'ACTIVE',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.SOME_SUSPENDED,
      label: 'Some Suspended',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.SUSPENDED,
      label: 'Suspended',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.SOME_DISCONNECTED,
      label: 'Some Disconnected',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.DISCONNECTED,
      label: 'DISCONNECTED',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.SOME_REACTIVATED,
      label: 'Some Reactivated',
      disabled: true,
    },
    {
      id: CompanyMasterServicesStatusIds.REACTIVATED,
      label: 'REACTIVATED',
      disabled: true,
    },
  ]
}

export const getCompanyMasterServiceStatusByLabel = getItemByLabelFactory(
  getCompanyMasterServicesStatii
)
export const getCompanyMasterServiceStatusById = getItemByIdFactory(
  getCompanyMasterServicesStatii
)
